(function() {
  // Countdown timer — starts 2 hours from page load
  var endTime = Date.now() + (2 * 60 * 60 * 1000);

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function updateTimer() {
    var remaining = endTime - Date.now();
    if (remaining <= 0) { remaining = 0; }
    var hrs = Math.floor(remaining / (1000 * 60 * 60));
    var min = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
    var sec = Math.floor((remaining % (1000 * 60)) / 1000);
    var display = pad(hrs) + ':' + pad(min) + ':' + pad(sec);

    var elBar = document.getElementById('timer-bar');
    if (elBar) elBar.textContent = display;

    var elInline = document.getElementById('timer-inline');
    if (elInline) elInline.textContent = display;

    if (remaining > 0) { setTimeout(updateTimer, 1000); }
  }

  updateTimer();
})();

// Sticky add-to-cart bar — appears after reason 3, hides at purchase section
(function() {
  var bar = document.getElementById('sticky-atc');
  if (!bar) return;
  var rows = document.querySelectorAll('.reason-row');
  var trigger = rows[2]; // zero-indexed: reason 3
  var purchase = document.querySelector('.purchase');

  function update() {
    if (!trigger) return;
    var triggerBottom = trigger.getBoundingClientRect().bottom;
    var pastTrigger = triggerBottom < 0;
    var atPurchase = purchase ? purchase.getBoundingClientRect().top < window.innerHeight * 0.75 : false;
    var show = pastTrigger && !atPurchase;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();
